import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dxf-project-portfolio" }
const _hoisted_2 = { class: "dxf-project-portfolio__project-list" }
const _hoisted_3 = { class: "dxf-project-portfolio__project-list-cards" }
const _hoisted_4 = { class: "dxf-project-portfolio__project-card" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card-title" }
const _hoisted_9 = { class: "card-subtitle" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "dxf-project-portfolio__project-list-filters" }
const _hoisted_12 = { class: "dxf-project-portfolio__project-list-filters-buttons-container" }
const _hoisted_13 = {
  class: "dxf-project-portfolio__project-list-filters-button btn btn-outline-primary",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#FilterCollapse",
  "aria-expanded": "true",
  "aria-controls": "collapseExample"
}
const _hoisted_14 = {
  class: "collapse dxf-project-portfolio__project-list-filters-sort",
  id: "SortCollapse"
}
const _hoisted_15 = { class: "dxf-project-portfolio__project-list-filters-sort-conteiner" }
const _hoisted_16 = {
  class: "collapse dxf-project-portfolio__project-list-filters-filter-container",
  id: "FilterCollapse"
}
const _hoisted_17 = { class: "dxf-project-portfolio__project-list-filters-filter" }
const _hoisted_18 = { class: "dxf-project-portfolio__project-list-filters-filter-header" }
const _hoisted_19 = { class: "d-flex flex-wrap my-3" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "dxf-project-portfolio__project-list-filters-filter-options" }
const _hoisted_22 = { class: "accordion accordion-lines" }
const _hoisted_23 = ["id"]
const _hoisted_24 = ["data-bs-target", "aria-controls"]
const _hoisted_25 = ["id", "aria-labelledby"]
const _hoisted_26 = { class: "accordion-body" }
const _hoisted_27 = { class: "d-flex flex-wrap" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "row dxf-project-portfolio__pagination my-5" }
const _hoisted_30 = { "aria-label": "pagination" }
const _hoisted_31 = { class: "pagination" }
const _hoisted_32 = { class: "icon-wrapper" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "page-link" }
const _hoisted_35 = { class: "page-item" }
const _hoisted_36 = { class: "page-link" }
const _hoisted_37 = { class: "icon-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visibleProjects, (project) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("a", {
              class: "card text-decoration-none",
              href: project.url
            }, [
              _createElementVNode("img", {
                src: project.primaryImage.url,
                class: "card-img-top card--hover-grow",
                alt: project.primaryImage.alt
              }, null, 8, _hoisted_6),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h3", _hoisted_8, _toDisplayString(project.title), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(project.subtitle), 1),
                _createElementVNode("p", {
                  class: "card-text",
                  innerHTML: project.summary
                }, null, 8, _hoisted_10)
              ])
            ], 8, _hoisted_5)
          ]))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "dxf-project-portfolio__project-list-filters-title" }, [
          _createElementVNode("h3", null, "Filter & Sort")
        ], -1)),
        _createElementVNode("div", _hoisted_12, [
          _cache[9] || (_cache[9] = _createElementVNode("button", {
            class: "dxf-project-portfolio__project-list-filters-button btn btn-outline-primary",
            type: "button",
            "data-bs-toggle": "collapse",
            "data-bs-target": "#SortCollapse",
            "aria-expanded": "true",
            "aria-controls": "collapseExample"
          }, [
            _createTextVNode(" Sort "),
            _createElementVNode("i", { class: "fas fa-sort-numeric-down-alt" })
          ], -1)),
          _createElementVNode("button", _hoisted_13, [
            _createTextVNode(" Filter (" + _toDisplayString($setup.selectedFilters.length) + ") ", 1),
            _cache[8] || (_cache[8] = _createElementVNode("i", { class: "far fa-filter" }, null, -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[11] || (_cache[11] = _createElementVNode("small", null, "Sort", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              "aria-label": "Select sorting mode",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.sortingOption) = $event))
            }, _cache[10] || (_cache[10] = [
              _createElementVNode("option", {
                value: "0",
                selected: ""
              }, "Date (newest to oldest)", -1),
              _createElementVNode("option", { value: "1" }, "Date (oldest to newest)", -1),
              _createElementVNode("option", { value: "2" }, "A-Z", -1),
              _createElementVNode("option", { value: "3" }, "Z-A", -1)
            ]), 512), [
              [_vModelSelect, $setup.sortingOption]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[13] || (_cache[13] = _createElementVNode("small", { class: "dxf-project-portfolio__project-list-filters-filter-header-title" }, "Filters", -1)),
              _withDirectives(_createElementVNode("div", {
                class: "dxf-project-portfolio__filter-clear-btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.clearAllFilters && $setup.clearAllFilters(...args)))
              }, _cache[12] || (_cache[12] = [
                _createElementVNode("small", null, "Clear all", -1),
                _createElementVNode("i", { class: "far fa-times-circle" }, null, -1)
              ]), 512), [
                [_vShow, $setup.selectedFilters.length > 0]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedFilters, (selectedFilter, i) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "dxf-project-portfolio__filter-tag",
                  key: i
                }, [
                  _createTextVNode(_toDisplayString(selectedFilter.displayName) + " ", 1),
                  _createElementVNode("i", {
                    class: "fal fa-times fa-sm dxf-project-portfolio__filter-tag-icon",
                    onClick: ($event: any) => ($setup.handleFilterClick(selectedFilter))
                  }, null, 8, _hoisted_20)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.availableFilters, (filter, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "accordion-item",
                  key: i
                }, [
                  _createElementVNode("h2", {
                    class: "accordion-header",
                    id: `headingLines-${i}`
                  }, [
                    _createElementVNode("button", {
                      class: "accordion-button collapsed",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": `#collapseLines-${i}`,
                      "aria-expanded": "false",
                      "aria-controls": `#collapseLines-${i}`
                    }, [
                      _createTextVNode(_toDisplayString(filter.displayName) + " ", 1),
                      _createElementVNode("i", {
                        class: "fal fa-angle-down",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.handleFilterClick(_ctx.selectedFilter)))
                      })
                    ], 8, _hoisted_24)
                  ], 8, _hoisted_23),
                  _createElementVNode("div", {
                    id: `collapseLines-${i}`,
                    class: "accordion-collapse collapse",
                    "aria-labelledby": `collapseLines-${i}`
                  }, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.options, (option, i) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: _normalizeClass([{selected: option.selected}, "dxf-project-portfolio__filter-tag dxf-project-portfolio__filter-tag--gray"]),
                            onClick: ($event: any) => ($setup.handleFilterClick(option)),
                            key: i
                          }, _toDisplayString(option.displayName), 11, _hoisted_28))
                        }), 128))
                      ])
                    ])
                  ], 8, _hoisted_25)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("nav", _hoisted_30, [
        _createElementVNode("ul", _hoisted_31, [
          _createElementVNode("template", _hoisted_32, [
            _createElementVNode("li", {
              class: "page-item page-icon",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.decreasePagerOffsetIn(1)))
            }, [
              _createElementVNode("a", {
                class: _normalizeClass([{disabled: $setup.pagerOffset <= 0}, "page-link"]),
                "aria-label": "Next"
              }, _cache[15] || (_cache[15] = [
                _createElementVNode("span", { "aria-hidden": "true" }, [
                  _createElementVNode("i", { class: "far fa-chevron-double-left" })
                ], -1)
              ]), 2)
            ]),
            _createElementVNode("li", {
              class: "page-item page-icon",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.decreaseSelectedPageIn(1)))
            }, [
              _createElementVNode("a", {
                class: _normalizeClass([{disabled: !$setup.showPrevButton}, "page-link"]),
                "aria-label": "Previous"
              }, _cache[16] || (_cache[16] = [
                _createElementVNode("span", { "aria-hidden": "true" }, [
                  _createElementVNode("i", { class: "far fa-angle-left" })
                ], -1)
              ]), 2)
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.amountOfPages, (n) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["page-item", {active: (n + ($setup.pagerOffset * $setup.amountOfPagerItems )) == $setup.pageSelected }]),
              onClick: ($event: any) => ($setup.moveSelectedPageTo(n + ($setup.pagerOffset * $setup.amountOfPagerItems)))
            }, [
              _createElementVNode("a", _hoisted_34, _toDisplayString(n + ($setup.pagerOffset * $setup.amountOfPagerItems )), 1)
            ], 10, _hoisted_33))
          }), 256)),
          _withDirectives(_createElementVNode("li", _hoisted_35, _cache[17] || (_cache[17] = [
            _createElementVNode("a", { class: "page-link disable-hover" }, "...", -1)
          ]), 512), [
            [_vShow, $setup.showMorePagesButton]
          ]),
          _withDirectives(_createElementVNode("li", {
            class: _normalizeClass(["page-item", {active: $setup.totalPages == $setup.pageSelected }]),
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.moveSelectedPageTo($setup.totalPages)))
          }, [
            _createElementVNode("a", _hoisted_36, _toDisplayString($setup.totalPages), 1)
          ], 2), [
            [_vShow, $setup.showMorePagesButton]
          ]),
          _createElementVNode("template", _hoisted_37, [
            _createElementVNode("li", {
              class: "page-item page-icon",
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.increaseSelectedPageIn(1)))
            }, [
              _createElementVNode("a", {
                class: _normalizeClass([{disabled: !$setup.showNextButton}, "page-link"]),
                "aria-label": "Next"
              }, _cache[18] || (_cache[18] = [
                _createElementVNode("span", { "aria-hidden": "true" }, [
                  _createElementVNode("i", { class: "far fa-angle-right" })
                ], -1)
              ]), 2)
            ]),
            _createElementVNode("li", {
              class: "page-item page-icon",
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.increasePagerOffsetIn(1)))
            }, [
              _createElementVNode("a", {
                class: _normalizeClass([{disabled: !$setup.showMorePagesButton}, "page-link"]),
                "aria-label": "Next"
              }, _cache[19] || (_cache[19] = [
                _createElementVNode("span", { "aria-hidden": "true" }, [
                  _createElementVNode("i", { class: "far fa-chevron-double-right" })
                ], -1)
              ]), 2)
            ])
          ])
        ])
      ])
    ])
  ]))
}